import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { appStates, setAppState } from "../redux/features/appStateSlice";
import { BaseDialog } from "./common/BaseDialog";
import { colors } from "./ui/colors";

const styles = {
  titleSx: {
    textAlign: "center",
    color: "var(--fx-surface-text, #0F172A)",
    fontWeight: 900,
    fontSize: "1.15rem",
    letterSpacing: "-0.02em",
  },

  actionsSx: {
    justifyContent: "center",
    gap: 1.5,
    px: 3,
    pb: 3,
  },

  btnCancelSx: {
    minWidth: 120,
    borderRadius: "999px",
    px: 2.5,
    py: 1,
    textTransform: "none",
    fontWeight: 800,
    color: "var(--fx-surface-textsecondary, #64748B)",
    backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
      boxShadow: "none",
    },
  },

  btnContinueSx: {
    minWidth: 120,
    borderRadius: "999px",
    px: 2.5,
    py: 1,
    textTransform: "none",
    fontWeight: 800,
    color: "#fff",
    backgroundColor: colors.orange.base,

    "&:hover": {
      backgroundColor: colors.orange[600] ?? colors.orange.base,
      boxShadow: "none",
    },
  },
};

export const ConnectBusinessExit = ({ open = false, setOpen = () => {}, continueAction = () => {} }) => {
  const dispatch = useDispatch();

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleContinue = () => {
    dispatch(setAppState({ currState: appStates.HOME }));
    continueAction();
    handleCloseDialog();
  };

  const actions = [
    {
      label: "Cancel",
      onClick: handleCloseDialog,
      style: styles.btnCancelSx,
    },
    {
      label: "Continue",
      onClick: handleContinue,
      style: styles.btnContinueSx,
    },
  ];

  const ExitMessage = () => {
    return (
      <Box
        sx={{
          px: 3,
          pt: 1,
          pb: 0.5,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            mx: "auto",
            mb: 2,
            borderRadius: "50%",
            bgcolor: "rgba(226, 135, 67, 0.1)",
            color: colors.orange.base,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WarningAmberRoundedIcon sx={{ fontSize: 34, color: colors.orange.base }} />
        </Box>

        <Typography
          sx={{
            color: "var(--fx-surface-textsecondary, #64748B)",
            fontSize: "0.92rem",
            fontWeight: 600,
            lineHeight: 1.55,
            maxWidth: 360,
            mx: "auto",
          }}
        >
          You haven't finished connecting your business yet. If you leave now, your current progress may be lost.
        </Typography>

        <Typography
          sx={{
            mt: 2,
            color: "var(--fx-surface-text, #0F172A)",
            fontSize: "0.95rem",
            fontWeight: 900,
            lineHeight: 1.35,
          }}
        >
          Are you sure you want to leave?
        </Typography>
      </Box>
    );
  };

  return (
    <BaseDialog
      openState={open}
      setOpenState={setOpen}
      title="Leave setup?"
      titleSx={styles.titleSx}
      content={<ExitMessage />}
      actionSx={styles.actionsSx}
      actions={actions}
    />
  );
};
